var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"wrapper main-wrapper"},[_c('sidebar'),(_vm.showUserProfil)?_c('div',{staticClass:"userProfile"}):_vm._e(),_c('div',[_c('div',{staticClass:"main-content"},[_vm._t("title"),_vm._t("default")],2)]),_vm._t("after"),_c('DashboardNote')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }